/** Shared schema for consultation + external lead questionnaires */

export const QUESTION_TYPES = [
  { value: 'text', label: 'Short text' },
  { value: 'textarea', label: 'Long text' },
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Phone' },
  { value: 'date', label: 'Date' },
  { value: 'time', label: 'Time' },
  { value: 'number', label: 'Number' },
  { value: 'select', label: 'Dropdown' },
];

/** Built-in external lead columns vendors can include/reorder */
export const SYSTEM_FIELD_IDS = [
  'guest_name',
  'guest_email',
  'guest_phone',
  'event_date',
  'event_time',
  'event_location',
  'event_type',
  'guest_count',
  'message',
];

export const DEFAULT_EXTERNAL_FORM_FIELDS = [
  {
    id: 'guest_name',
    type: 'text',
    label: 'Your name',
    required: true,
    system: true,
    placeholder: 'Full name',
  },
  {
    id: 'guest_email',
    type: 'email',
    label: 'Email',
    required: false,
    system: true,
    placeholder: 'you@example.com',
  },
  {
    id: 'guest_phone',
    type: 'phone',
    label: 'Phone',
    required: false,
    system: true,
    placeholder: '+1 …',
  },
  {
    id: 'event_date',
    type: 'date',
    label: 'Event date',
    required: false,
    system: true,
  },
  {
    id: 'event_time',
    type: 'time',
    label: 'Time',
    required: false,
    system: true,
  },
  {
    id: 'event_location',
    type: 'text',
    label: 'Location',
    required: false,
    system: true,
    placeholder: 'City or venue',
  },
  {
    id: 'event_type',
    type: 'text',
    label: 'Event type',
    required: false,
    system: true,
    placeholder: 'Wedding, party…',
  },
  {
    id: 'guest_count',
    type: 'number',
    label: 'Guest count',
    required: false,
    system: true,
    placeholder: 'Approx.',
  },
  {
    id: 'message',
    type: 'textarea',
    label: 'Message',
    required: false,
    system: true,
    placeholder: 'Tell us what you need…',
  },
];

export const newCustomField = () => ({
  id: `q_${Date.now()}`,
  type: 'text',
  label: '',
  required: false,
  options: [],
  placeholder: '',
  system: false,
});

export const isSystemField = (field) =>
  Boolean(field?.system) || SYSTEM_FIELD_IDS.includes(field?.id);

/** Same pipeline as Internal consultations (config/consultation_leads.php) */
export const EXTERNAL_LEAD_STATUSES = [
  { key: '', label: 'All' },
  { key: 'pending', label: 'Pending' },
  { key: 'meeting_scheduled', label: 'Meeting scheduled' },
  { key: 'meeting_done', label: 'Meeting done' },
  { key: 'booked', label: 'Booked' },
  { key: 'lead_not_responsive', label: 'Not responsive' },
  { key: 'lead_cancelled', label: 'Cancelled' },
  { key: 'rejected', label: 'Rejected' },
];

/** Kanban: 6 columns → 2 rows × 3 */
export const PIPELINE_BOARD_STATUSES = [
  'pending',
  'meeting_scheduled',
  'meeting_done',
  'booked',
  'lead_not_responsive',
  'lead_cancelled',
];
